import { Flex, theme } from 'antd'
import { ModeSwitch } from './ModeSwitch.tsx'
import { Threshold } from './Threshold.tsx'
import { ExportDropdown } from './ExportDropdown.tsx'
import { SettingsEditorPopup } from "./settings/SettingsEditorPopup.tsx"

const { useToken } = theme

export const DiagramActions = () => {
    const { token } = useToken()

    return (<Flex style={{ margin: token.marginXS, position: 'absolute', zIndex: 1 }} gap={6} vertical>
        <Flex gap={6} justify='center' align='center'>
            <SettingsEditorPopup />
            <ExportDropdown />
            <ModeSwitch />
        </Flex>
        <Threshold />
    </Flex>)
}
